var app = angular
    .module('mediciones')
    .factory('medicionesService', ['$http', '$q', '__env', '$routeParams', function inspeccionesService($http, $q, __env, $routeParams) {
        var serviceUrl = __env.apiUrl;
        var medicionesUrl = 'mediciones';
        var presasUrl = 'presas';


        function getMedicionesAforadores(idPresa) {
            return $http.get(serviceUrl + medicionesUrl + "/aforadores/" + idPresa);
        }

        function getMedicionesCaudales(idPresa) {
            return $http.get(serviceUrl + medicionesUrl + "/caudal/" + idPresa);
        }

        function getMedicionesInclinometros(idPresa) {
            return $http.get(serviceUrl + medicionesUrl + "/inclinometros/" + idPresa);
        }

        function getMedicionesJuntas(idPresa) {
            return $http.get(serviceUrl + medicionesUrl + "/juntas/" + idPresa);
        }

        function getMedicionesPendulos(idPresa) {
            return $http.get(serviceUrl + medicionesUrl + "/pendulos/" + idPresa);
        }

        function getMedicionesPiezometros(idPresa) {
            return $http.get(serviceUrl + medicionesUrl + "/piezometros/" + idPresa);
        }

        function getMedicionesOtras(idPresa) {
            return $http.get(serviceUrl + medicionesUrl + "/otras/" + idPresa);
        }

        function getPresa(idInfraestructura) {
            return $http.get(serviceUrl + presasUrl + "/infraestructura/" + idInfraestructura);
        }

        return {

            getMedicionesAforadores: getMedicionesAforadores,
            getMedicionesCaudales: getMedicionesCaudales,
            getMedicionesInclinometros: getMedicionesInclinometros,
            getMedicionesJuntas: getMedicionesJuntas,
            getMedicionesPendulos: getMedicionesPendulos,
            getMedicionesPiezometros: getMedicionesPiezometros,
            getMedicionesOtras: getMedicionesOtras,
            getPresa: getPresa

        }
    }]);